import { useReactToPrint } from "react-to-print";
import { RefObject } from "react";

type UsePrintOptions = {
  documentTitle?: string;
  pageStyle?: string;
};

export function usePrint(
  ref: RefObject<HTMLElement>,
  options?: UsePrintOptions
) {
  return useReactToPrint({
    contentRef: ref,
    documentTitle: options?.documentTitle ?? "Document",
    pageStyle: options?.pageStyle,
  });
}
